document.addEventListener('alpine:init', () => {
  Alpine.data('ctrItemSlider', () => ({
    swiper: null,
    swiperRetries: 0,

    init() {
      this.initSwiper();
    },

    destroy() {
      this.destroySwiper();
    },

    initSwiper() {
      if (this.swiper) return;

      if (typeof Swiper === 'undefined') {
        if (this.swiperRetries >= 40) return;
        this.swiperRetries += 1;
        window.setTimeout(() => this.initSwiper(), 50);
        return;
      }

      const swiperEl = this.$el.querySelector('[ref="swiper"]');
      if (!swiperEl) return;

      const loop = this.$el.dataset.loop !== 'false';
      const prevEl = this.$el.querySelector('[ref="prev"]');
      const nextEl = this.$el.querySelector('[ref="next"]');

      const config = {
        slidesPerView: 'auto',
        loop: loop,
        spaceBetween: 20,
        slidesOffsetAfter: 20,
        touchEventsTarget: 'container',
        simulateTouch: true,
        allowTouchMove: true,
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        shortSwipes: true,
        longSwipes: true,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        },
        breakpoints: {
          991: {
            slidesPerView: 3,
            slidesOffsetAfter: 0,
          },
        },
      };

      if (prevEl && nextEl) {
        config.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      this.swiper = new Swiper(swiperEl, config);
    },

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    },
  }));
});
